/**
 * Parse the time to string
 * @param {(Object|string|number)} time
 * @param {string} cFormat
 * @returns {string | null}
 */
// eslint-disable-next-line no-unused-vars
import store from "@/store";
import router from "@/router";
// import { getWanvToken, aesEncryption } from "@/api/app.js";
import CryptoJS from "crypto-js"; //DES加密
const iv = CryptoJS.enc.Utf8.parse("je3ipSatfxz22437"); //十六位十六进制数作为秘钥偏移量，与后台一致
// import JSEncrypt from "@/utils/jsencrypt.js"; // RSA加密
import request from "@/utils/request";
// eslint-disable-next-line no-unused-vars
import Qs from "qs";
// eslint-disable-next-line no-unused-vars
export function parseTime(time, cFormat) {
  if (arguments.length === 0) {
    return null;
  }
  const format = cFormat || "{y}-{m}-{d} {h}:{i}:{s}";
  let date;
  if (typeof time === "object") {
    date = time;
  } else {
    if (typeof time === "string" && /^[0-9]+$/.test(time)) {
      time = parseInt(time);
    }
    if (typeof time === "number" && time.toString().length === 10) {
      time = time * 1000;
    }
    date = new Date(time);
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  };
  const time_str = format.replace(/{([ymdhisa])+}/g, (result, key) => {
    const value = formatObj[key];
    // Note: getDay() returns 0 on Sunday
    if (key === "a") {
      return ["日", "一", "二", "三", "四", "五", "六"][value];
    }
    return value.toString().padStart(2, "0");
  });
  return time_str;
}
export function publicKey() {
  return "-----BEGIN PUBLIC KEY-----MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQC+BCyZoozveRVSV4o2oREzjBbxBNhlVbCVe4laV/4slpFA63DbYMEIYvzDcQ7cPFCJpbRFC6GrnTAqzqKmYR7Ij177uuz3vLdP9KcYgcmc4VJW8noeM4oXPrbhK8N5igloWGk3wjcaIXxgq0oOA+nA35ghz9gQsh1E2BfqjuFWiQIDAQAB-----END PUBLIC KEY-----";
}
/**
 *获取最近天数
 * @param {*} p_count
 * @returns
 */
export function FunGetDateStr(p_count) {
  let dd = new Date();
  dd.setDate(dd.getDate() + p_count); //获取p_count天后的日期
  let y = dd.getFullYear();
  let m = dd.getMonth() + 1; //获取当前月份的日期
  if (m < 10) {
    m = "0" + m;
  }
  let d = dd.getDate();
  if (d < 10) {
    d = "0" + d;
  }
  return y + "-" + m + "-" + d;
}
/**
 * @param {number} time
 * @param {string} option
 * @returns {string}
 */
export function formatTime(time, option) {
  if (("" + time).length === 10) {
    time = parseInt(time) * 1000;
  } else {
    time = +time;
  }
  const d = new Date(time);
  const now = Date.now();

  const diff = (now - d) / 1000;

  if (diff < 30) {
    return "刚刚";
  } else if (diff < 3600) {
    // less 1 hour
    return Math.ceil(diff / 60) + "分钟前";
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + "小时前";
  } else if (diff < 3600 * 24 * 2) {
    return "1天前";
  }
  if (option) {
    return parseTime(time, option);
  } else {
    return (
      d.getMonth() +
      1 +
      "月" +
      d.getDate() +
      "日" +
      d.getHours() +
      "时" +
      d.getMinutes() +
      "分"
    );
  }
}

/**
 * @param {string} url
 * @returns {Object}
 */
export function param2Obj(url) {
  const search = url.split("?")[1];
  if (!search) {
    return {};
  }
  return JSON.parse(
    '{"' +
      decodeURIComponent(search)
        .replace(/"/g, '\\"')
        .replace(/&/g, '","')
        .replace(/=/g, '":"')
        .replace(/\+/g, " ") +
      '"}'
  );
}

/**
 * @param {Function} func
 * @param {number} wait
 * @param {boolean} immediate
 * @return {*}
 */
export function debounce(func, wait, immediate) {
  let timeout, args, context, timestamp, result;

  const later = function() {
    // 据上一次触发时间间隔
    const last = +new Date() - timestamp;

    // 上次被包装函数被调用时间间隔 last 小于设定时间间隔 wait
    if (last < wait && last > 0) {
      timeout = setTimeout(later, wait - last);
    } else {
      timeout = null;
      // 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
      if (!immediate) {
        result = func.apply(context, args);
        if (!timeout) context = args = null;
      }
    }
  };

  return function(...args) {
    context = this;
    timestamp = +new Date();
    const callNow = immediate && !timeout;
    // 如果延时不存在，重新设定延时
    if (!timeout) timeout = setTimeout(later, wait);
    if (callNow) {
      result = func.apply(context, args);
      context = args = null;
    }

    return result;
  };
}
/**
 *
 * @param {*} hex 16进制
 * @param {*} opacity 透明度
 * @returns
 */
export function hexToRgba(hex, opacity) {
  return (
    "rgba(" +
    parseInt("0x" + hex.slice(1, 3)) +
    "," +
    parseInt("0x" + hex.slice(3, 5)) +
    "," +
    parseInt("0x" + hex.slice(5, 7)) +
    "," +
    opacity +
    ")"
  );
}
/**
 *
 * @param {*} 三位一逗号
 * @param {*}
 * @returns
 */
export function tempNum(num) {
  return num.toString().replace(/(\d)(?=(?:\d{3})+$)/g, "$1,");
}
export function nodeStyle(d) {
  d.cursor = "pointer";
  d.label = subName(d.data.name, d.data.value);
  let type = d.data.type;
  let code = store.getters.linkCode;
  if (code == d.data.code) {
    d.radius = d.radius * 1.2;
  }
  if (type == "A") {
    d.lineColor = "#f2820b";
    d.fillColor = "#f2820b";
    d.image = require("../assets/images/link.png");
  } else if (type == "B") {
    d.lineColor = "#4991f4";
    d.fillColor = "#4991f4";
    d.image = require("../assets/images/link.png");
  } else {
    d.lineColor = "#4991f4";
    d.lineDash = [5];
    d.fillColor = "transparent";
    d.image = require("../assets/images/lack.png");
  }
}
export function nodeStyleNoNum(d) {
  d.cursor = "pointer";
  d.label = subNameNoNum(d.data.name, d.data.value);
  // let type = d.data.type;
  // console.log(type);
  let code = store.getters.linkCode;
  if (code == d.data.code) {
    d.radius = d.radius * 1.2;
  }
  // if (type == "A") {
  //   d.lineColor = "#f2820b";
  //   d.fillColor = "#f2820b";
  //   d.image = require("../assets/images/link.png");
  // } else if (type == "B") {
  d.lineColor = "rgba(0 ,126 ,255,1)";
  d.fillColor = "rgba(0 ,126 ,255,0.2)";
  d.image = require("../assets/images/link.png");
  // } else {
  //   d.lineColor = "#4991f4";
  //   d.lineDash = [5];
  //   d.fillColor = "transparent";
  //   d.image = require("../assets/images/lack.png");
  // }
}
function group(ss, step) {
  var r = [];
  function doGroup(s) {
    if (!s) return;
    r.push(s.substr(0, step));
    s = s.substr(step);
    doGroup(s);
  }
  doGroup(ss);
  return r;
}
export function subName(arr, number) {
  if (!arr) return "";
  var name = "";
  let list = group(arr, 8);
  name += list.join("<br>") + "<br>" + number;
  return name;
}
// eslint-disable-next-line no-unused-vars
export function subNameNoNum(arr, number) {
  if (!arr) return "";
  var name = "";
  name += arr;
  return name;
}
export function linkStyle(d) {
  d.fillColor = "rgba(91, 125, 215, 1)";
}
export function localization_zh() {
  var toolbar = {
    toolbar: {
      backButton: "回退",
      backTitle: "回退",
      exportButton: "导出",
      exportCSV: "Spreadsheet (csv)",
      exportJpeg: "For Office and Web (jpeg)",
      exportPDF: "For Printer (pdf)",
      exportPNG: "For Photoshop (png)",
      exportTitle: "Export Data",
      exportXLS: "Spreadsheet (xls)",
      fitButton: "Fit",
      fitTitle: "适合屏幕",
      freezeButton: "Freeze",
      freezeTitle: "全部锁定",
      fullscreenButton: "全屏",
      fullscreenTitle: "切换全屏模式",
      rearrangeButton: "重新排列",
      rearrangeTitle: "重新排列元素",
      unfreezeTitle: "解锁全部",
      zoomoutButton: "Zoom-out",
      zoomoutTitle: "Zoom out"
    }
  };
  return toolbar;
}
export function jumpPath(type, entName, param) {
  //industryData
  if (type == "QYXQ") {
    window.open(
      "https://sipent.wanvdata.com/forward/toTopEntInfo.do?infoType=1&entName=" +
        encodeURI(encodeURI(`${entName}`)) +
        "&userName=industryData&sourceType=1&param=" +
        param
    );
  }
}
// export async function jumpGraph(type, entName) {
//   let res = await getWanvToken();
//   let data = res.data;
//   if (data.success) {
//     let res = await aesEncryption(data.token);
//     jumpPath(type, entName, res.data.param);
//   } else {
//     this.$message({
//       message: "获取token失败",
//       type: "error",
//       duration: 3 * 1000
//     });
//   }
// }
export function floatMul(arg1, arg2) {
  var m = 0,
    s1 = arg1.toString(),
    s2 = arg2.toString();
  try {
    m += s1.split(".")[1].length;
    // eslint-disable-next-line no-empty
  } catch (e) {}
  try {
    m += s2.split(".")[1].length;
    // eslint-disable-next-line no-empty
  } catch (e) {}
  return (
    (Number(s1.replace(".", "")) * Number(s2.replace(".", ""))) /
    Math.pow(10, m)
  );
}
/**
 * 生成32位字符串
 * @param {number || ''} number
 * @returns {string}
 */
export function randomString(number) {
  let e = number || 32;
  var t = "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678",
    a = t.length,
    n = "";
  for (let i = 0; i < e; i++) n += t.charAt(Math.floor(Math.random() * a));
  return n;
}

export function throttle(fn, wait) {
  let pre = 0;
  return function(...args) {
    let now = Date.now();
    if (now - pre >= wait) {
      fn.apply(this, args);
      pre = now;
    }
  };
}

//处理 路由权限
export function routeFilter() {
  //后台返回的权限集合
  let listN = [],
    listCallback = store.getters.roleMenuList || [];
  for (let index = 0; index < listCallback.length; index++) {
    const element = listCallback[index];

    if (element.url && element.url.includes("menu_")) {
      listN.push(element.url.split("_")[1]);
    }
  }
  //过滤 一级
  let data = router.options.routes.filter(item => {
    return listN.includes(item.meta.title);
  });

  //过滤 二级
  for (let index = 0; index < data.length; index++) {
    const element = data[index];
    element.children = element.children.filter(item => {
      return listN.includes(item.meta.title);
    });
  }

  return data;
}
//处理 按钮权限
export function btnFilter() {
  //后台返回的权限集合
  let listN = [],
    listCallback = store.getters.roleMenuList || [];
  for (let index = 0; index < listCallback.length; index++) {
    const element = listCallback[index];

    if (element.url && element.url.includes("btn_")) {
      listN.push(element.url.split("_")[1]);
    }
  }
  return listN;
}

/**
 * token  交换
 */
export function mathToken(data) {
  return request({
    url: "/lxCallBack",
    method: "post",
    data: Qs.stringify(data)
  });
}
/**
 * AES加密
 * @param {} word
 * @returns
 */
export function encrypt(word) {
  // 判断是否存在keyStr，不存在就用默认的keyStr（注意：这个keyStr必需要前后端统一，不然双方加密解密后会不相同。调用generatekey方法生成）
  let key = CryptoJS.enc.Utf8.parse("a8aRks4aApAXes28cRRJdknFPJn8iTi5");
  let srcs = CryptoJS.enc.Utf8.parse(word);
  let encrypted = CryptoJS.AES.encrypt(srcs, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  });
  return encrypted.toString();
}
/**
 * AES解密
 * @param {} word
 * @returns
 */
export function decrypt(word) {
  let key = CryptoJS.enc.Utf8.parse("a8aRks4aApAXes28cRRJdknFPJn8iTi5");
  let decrypt = CryptoJS.AES.decrypt(word, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  });
  return CryptoJS.enc.Utf8.stringify(decrypt).toString();
}
